<template lang="pug">
    div(v-if="type === 'output'" :class="[ 'column', columnConfig.key ]")
        router-link(v-if="link" :to="link")
            slot(name="prefix" v-bind:value="value")
            slot(v-bind:value="value")
                .content(v-html="value")
            slot(name="suffix" v-bind:value="value")
        template(v-else)
            slot(name="prefix" v-bind:value="value")
            slot(v-bind:value="value")
                .content(v-html="value")
            slot(name="suffix" v-bind:value="value")
    div(v-else-if="type === 'list'")
        slot(name="prefix" v-bind:value="value")
        slot(v-bind:value="value")
            ul
                li(v-for="element in value") {{ element }}
        slot(name="suffix" v-bind:value="value")
</template>

<script>
import _ from 'lodash';
import { timestamp2date, selectfilter, multiselectfilter } from '@/filters';

export default {
    name: 'PaginationColumn',
    props: {
        item: {
            type: Object,
            required: true
        },
        columnConfig: {
            type: Object,
            required: true
        }
    },
    // data() {
    //     return {
    //         type: 'simple',
    //     }
    // },
    computed: {
        data() {
            const path = this.columnConfig.value_path;
            const type = _.get(this.columnConfig, 'filter.type');

            let value = _.enhancedGet(this.item, path, '');
            switch (type) {
                case 'DateFromTo':
                    value = timestamp2date(value, this.$t('yyyy-MM-dd'));
                    break;
                case 'DateTimeFromTo':
                    value = timestamp2date(value, this.$t('yyyy-MM-dd') + ', HH:mm');
                    break;
                case 'Select':
                    value = selectfilter(value);
                    break;
                case 'MultiSelect':
                    value = multiselectfilter(value);
                    break;
                default:
                // FromTo
                // NumberFromTo
                // SingleInput
                // MultiSelect
            }

            let result = { type: 'output', value };
            if (_.isArray(value)) result.type = 'list';
            return result;
        },
        type() {
            return this.data.type;
        },
        value() {
            return this.data.value;
        },
        link() {
            let link = false;

            const data = _.get(this.columnConfig, 'link');
            if (data) {
                const id = _.enhancedGet(this.item, data.value_path, '');
                link = `${data.route}${id}`;
            }

            return link;
        }
    }
};
</script>

<style lang="sass" scoped>
ul
    margin: 0
    padding-left: 1em
.content:deep()
    p
        margin: 0
        // & + p
        //     margin-top: 10px
    ul
        margin: 0
        padding-left: 1em
</style>
